import React, { FC, useMemo } from 'react';
import posed from 'react-pose';
import { useSelector } from 'react-redux';

import { RootState } from '../../types';

import './index.scss';

const AnimateLoader = posed.li({
  open: {
    opacity: 1,
    height: '100vh',
    width: '100vw',
    transition: {
      opacity: {
        ease: 'linear',
        duration: 100,
      },
      height: {
        duration: 0,
      },
      width: {
        duration: 0,
      },
    },
  },
  close: {
    opacity: 0,
    height: 0,
    width: 0,
    delay: 500,
    transition: {
      opacity: {
        ease: 'linear',
        duration: 1000,
      },
      height: {
        duration: 0,
      },
      width: {
        duration: 0,
      },
    },
  },
});

const Loader: FC<{ singup?: boolean }> = ({ singup }) => {
  const loaderOperationsSign = useSelector(
    (state: RootState) => state.operationsSign.loading
  );
  const loaderCreditDetails = useSelector(
    (state: RootState) => state.creditDetails.loading
  );

  const { lastSale, lastPurchase, ...loaderOperations } = loaderOperationsSign;
  const loaderSignup = useSelector((state: RootState) => state.signup.loading);

  const loaders = useMemo(
    () =>
      Object.values(
        singup
          ? loaderSignup
          : Object.assign(loaderOperations, loaderCreditDetails)
      ).filter((i) => i),
    [singup, loaderSignup, loaderOperations]
  );

  return (
    <AnimateLoader pose={loaders.length ? 'open' : 'close'} className="loader">
      <svg
        version="1.1"
        className="svg-loader"
        x="0px"
        y="0px"
        width="40px"
        height="40px"
        viewBox="0 0 50 50"
      >
        <path
          fill="#000"
          d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
        >
          <animateTransform
            attributeType="xml"
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="0.6s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </AnimateLoader>
  );
};

export default Loader;
